import {StyleSheet} from 'react-native';
import OffersLightBulb from 'src/components/img/svg/OffersLightBulb';
import Styles from 'src/components/Styles';
import {OfferStylesDescriptor} from 'src/components/elements/offers/descriptor/DescriptorType';

export function offerNoteIcon(): JSX.Element {
  return <OffersLightBulb fill={Styles.Colors.Aramark.sky} />;
}

export function offerStyles(): OfferStylesDescriptor {
  return StyleSheet.create({
    offerNoteContainer: {
      minHeight: 57,
      justifyContent: 'center',
      alignItems: 'flex-start',
      borderWidth: 1,
      borderRadius: Styles.Spacing.m1,
      borderColor: Styles.Colors.Aramark.sky,
      backgroundColor: Styles.Colors.Aramark.toastBg,
      marginTop: Styles.Spacing.m3,
      marginHorizontal: Styles.Spacing.m3,
    },
    noteTextStyle: {
      color: Styles.Colors.Aramark.black01,
      fontWeight: '400',
      fontSize: Styles.Fonts.f0,
      paddingRight: Styles.Heights.h2,
      fontFamily: Styles.FontFamily.gothamRegular,
      paddingLeft: Styles.Spacing.m2 + Styles.Spacing.m1,
      marginBottom: Styles.Spacing.m2 + Styles.Spacing.m1,
      marginTop: Styles.Spacing.m2,
    },
    noteStyle: {
      fontSize: Styles.Fonts.f0,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.Aramark.black01,
    },
    offerExpiry: {
      color: Styles.Colors.PayNew.darkHuesBase04,
      fontSize: Styles.Fonts.f0,
      fontWeight: '400',
      minHeight: 17,
      textAlign: 'center',
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    appliedIcon: {marginTop: 2},
    offerTitleinModal: {
      left: 1,
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      marginVertical: Styles.Spacing.m1,
    },
    offersWithImageText: {
      textAlign: 'center',
    },
    validityText: {
      textAlign: 'center',
    },
    offersWithImageView: {
      alignSelf: 'center',
    },
  });
}

export function getTextColor(): string {
  return Styles.Colors.PayNew.darkHuesBase03;
}
export function primaryColor(): string {
  return Styles.Colors.Canteen.lightGray;
}
export function deafultIconInnerColor(): string {
  return Styles.Colors.Aramark.primary;
}
export function offerFontFamily(): string {
  return Styles.FontFamily.gothamRegular;
}
export function buttonAndIconColor(): string {
  return Styles.Colors.Aramark.primary;
}
export function addIconColor(): string {
  return Styles.Colors.Aramark.primary;
}
export function checkIconSize(): number {
  return Styles.Spacing.m3;
}
export function getOfferModalTextColor(): string {
  return Styles.Colors.PayNew.black01;
}
export function descNumberofLines(): number | null {
  return null;
}
export function legaleseNumberofLines(): number | null {
  return null;
}

export function offerDetailsArrowGif(): JSX.Element {
  return null;
}

export function defaultIconBackgroundColor(): string {
  return Styles.Colors.PayNew.neutralHuesBase12;
}
export function offerDetailCheckmark(): string {
  return Styles.Colors.PayNew.white01;
}
export function offerNameTextSize(): number {
  return Styles.Fonts.f1;
}
export function offerBtnTextSize(): number {
  return Styles.Fonts.f0;
}

export default {
  offerNoteIcon,
  offerStyles,
  getTextColor,
  primaryColor,
  deafultIconInnerColor,
  offerFontFamily,
  buttonAndIconColor,
  addIconColor,
  checkIconSize,
  getOfferModalTextColor,
  offerDetailsArrowGif,
  descNumberofLines,
  legaleseNumberofLines,
  defaultIconBackgroundColor,
  offerDetailCheckmark,
  offerNameTextSize,
  offerBtnTextSize,
};
